// extracted by mini-css-extract-plugin
module.exports = {"root":"Screen_root__3ezCB"};